import Vue from 'vue'
import Vuex from 'vuex'
import firebase from "firebase/app";
import fireBaseConfig from "../firebase_config.json";
import { AuthService, FireBaseAuthService } from '@/services/auth-service'
import { ApiService, ToolboxApiService } from '@/services/api-service'
import { AnalyticsService, AnalyticsServiceImpl } from '@/services/analytics-service'
const Cookies = require('js-cookie')
//need to initialize firebase app before calling dependant services like analytics
firebase.initializeApp(fireBaseConfig)
const apiService: ApiService = new ToolboxApiService()
const analyticsService: AnalyticsService = new AnalyticsServiceImpl()
const authService: AuthService = new FireBaseAuthService(apiService, analyticsService)
var timeout
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: null,
    analyticsService: analyticsService,
    authService: authService,
    apiService: apiService,
    isLoading: false,
    loggingIn: false,
    reauthRequired: false,
    manager: null
  },
  mutations: {
    currentUser(state, data) {
      state.currentUser = data
    },
    isLoading(state, val) {
      state.isLoading = val
    },
    manager(state, val) {
      state.manager = val
    },
    loggingIn(state, val) {
      state.loggingIn = val
      if (val === false) {
        state.reauthRequired = false
      }
    },
    reauthRequired(state) {
      state.reauthRequired = true
    }
  },
  actions: {
    currentUser({ commit }, val) {
      commit('currentUser', val)
    },
    isLoading({ commit }, val) {
      if (val) {
        // timeout = setTimeout(() => {
          commit('isLoading', true)
        // }, 500)
      } else {
        clearTimeout(timeout)
        commit('isLoading', false)
      }
    },
    async getUser({ commit, state }) {
      if (state.currentUser) {
        this.dispatch('getManager')
        return
      }
      this.dispatch('isLoading', true)
      let user = await state.authService.getUser()
      this.dispatch('isLoading', false)
      commit('currentUser', user)
    },
    async getManager({ commit, state }) {
      if (state.manager) return
      //this called twice, would be good to get it called once - or even not at all anymore / only when you grab "Profile"
      let manager = await state.apiService.getManager() 
      commit('manager', manager)
    },
    login({ commit }, reauth) {
      if (reauth) commit('reauthRequired')
      commit('loggingIn', true)
    },
    cancelLogin({ commit }) {
      commit('loggingIn', false)
      this.dispatch('logout', false)
    },
    authenticate({ commit, state }) {
      commit('loggingIn', false)
      state.authService.login()
    },
    async logout({ state }) {
      this.dispatch('isLoading', true)
      await state.authService.logout()
      this.dispatch('isLoading', false)
      Cookies.remove('fc_cr')
      if (window.location.pathname !== '/') window.location.href = '/'
    }
  },
  modules: {
  },
  getters: {
    isLoggedIn: (state) => {
      return !!state.currentUser
    },
    reauthRequired: (state) => {
      return !!state.reauthRequired
    },
    manager: (state) => {
      return state.manager
    },
    currentUser: (state) => {
      return state.currentUser
    },
    isLoading: (state) => {
      return state.isLoading
    }
  }
})
